module.exports = __webpack_public_path__ + "static/media/voice-2.2f1d885e.ogg";